<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-4">
                    <form class="form-group" v-on:submit.prevent="findCard">
                        <label>شماره کارت</label>
                        <div class="input-group">
                            <input type="tel" class="form-control text-center" v-mask="'####-####-####-####'" v-model="pan" dir="ltr" style="direction: ltr !important">
                            <span class="input-group-btn" v-if="pan && pan.replace(/-/g,'').length == 16"><button class="btn ripple btn-info" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                        </div>
                    </form>
                </div>
            </div>
            <hr v-if="events.length && searched">
            <div class="row mt-3" v-if="events.length && searched">
                <div class="col-12">
                    <table class="table table-bordered table-hover mb-0">
                        <thead>
                            <th>ردیف</th>
                            <th>عنوان رویداد</th>
                            <th>توضیحات</th>
                            <th>انجام دهنده</th>
                            <th>تاریخ</th>
                            <th>زمان</th>
                        </thead>
                        <tbody>
                            <tr v-for="(event,index) in events" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ event.action }}</td>
                                <td>{{ event.description || '-' }}</td>
                                <td>{{ event.domain_data_title || '-' }}</td>
                                <td>{{ event.trn_date.replace(/\//g,'').slice(0,4) + '-' + event.trn_date.replace(/\//g,'').slice(4,6) + '-' + event.trn_date.replace(/\//g,'').slice(6,8) }}</td>
                                <td>{{ event.trn_time }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row mt-3" v-if="!events.length && searched">
                <div class="col-12">
                    <div class="alert alert-info mb-0">
                        <p class="mb-0">اطلاعات کارت وارد شده یافت نشد</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    data(){
        return {
            showLoading: false,
            pan: '505785',
            events: [],
            searched: false,
            customer: {},
            customerId: 0
        }
    },
    methods: {
        searchCustomer(){
            this.legalCustomerDetails = {};
            const postedData = {
                company: true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status)
                    this.legalCustomerDetails = data.result;
                this.customerId = data.result.customerId;
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        findCard(){
            this.showLoading = true;
            const postedData = {
                // customerId: this.customerId || 0,
                p_card: this.pan.replace(/-/g,''),
                p_offset: 0,
                p_limit: 500,
                excel: false
                // isAdmin: this.customerId ? true : false
            };
            this.$api.post('Branches/Report/Card',postedData).then(({data}) => {
                if(data.status && data.result && data.result.v_result.length){
                    this.events = data.result.v_result;
                    this.customer = data.result.v_consumer[0];
                    // window.open('https://cardapi.sabinarya.com/' + data.result.fileName)
                }
            }).finally(() => {
                this.searched = true;
                this.showLoading = false;
            });
        }
    }
}
</script>